import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TitleRow, { TitleAction } from "../../../../shared/components/TitleRow";
import { CreateProviderTitleBar, WarningProviderModal } from "../../../../configs/provider";
import CancelModal from "../../../../shared/components/CancelModal";

interface TitleProps {
    setValidated: Function;
    submitForm: Function;
    isLoading?: boolean;
}

const Title = ({
    setValidated,
    submitForm,
    isLoading = false,
}:
  TitleProps
) => {
    const navigate = useNavigate();
    const [showCancelModal, setShowCancelModal] = useState(false);

    const handleCancel = () => {
        setShowCancelModal(true);
    };

    const handleConfirmCancel = () => {
        setShowCancelModal(false);
        navigate("/providers/");
    };

    const titleActions: TitleAction[] = [
        {
            title: CreateProviderTitleBar.cancelButton,
            onClick: handleCancel,
        },
        {
            title: CreateProviderTitleBar.addButton,
            variant: "contained",
            isLoading,
            onClick: () => {
                if (isLoading) return;
                setValidated(true);
                submitForm();
            },
        },
    ];

    return (
        <>
            <TitleRow title={CreateProviderTitleBar.title} actions={titleActions} />
            {showCancelModal && (
              <CancelModal
                title={WarningProviderModal.title}
                contentText={WarningProviderModal.context}
                open={showCancelModal}
                handleClose={() => setShowCancelModal(false)}
                handleConfirm={handleConfirmCancel}
              />
            )}
        </>
    );
};

export default Title;
